import {Text} from "@mantine/core";
import {Trans, useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import {dibAppApi} from "../../../../dibAppApi/dibAppApi";
import {ChecklistModal} from "../ChecklistModal";
import {buildCollectionUrl, type TopicMeta} from "./utils";
import classes from "../modalStyles.module.css";

type DeleteFillingModalProps = {
    opened: boolean;
    onClose: () => void;
    collectionId: string;
    collectionName: string;
    topicMeta: TopicMeta;
};

export const DeleteFillingModal = ({
    opened,
    onClose,
    collectionId,
    collectionName,
    topicMeta,
}: DeleteFillingModalProps) => {
    const {t} = useTranslation();
    const navigate = useNavigate();
    const [deleteFilling, {isLoading}] =
        dibAppApi.endpoints.deleteFilling.useMutation();

    const handleDelete = () => {
        if (!collectionId || !topicMeta.topicId) return;

        deleteFilling({
            collectionId,
        })
            .unwrap()
            .then(() => {
                navigate(buildCollectionUrl(topicMeta));
                onClose();
            });
    };

    return (
        <ChecklistModal
            opened={opened}
            onClose={onClose}
            title={t("Action.DeleteFilling")}
            primary={{
                label: t("common.delete"),
                onClick: handleDelete,
                variant: "destructive",
                loading: isLoading,
            }}
            secondary={{
                label: t("common.cancel"),
                onClick: onClose,
                disabled: isLoading,
            }}
        >
            <Text className={classes.modalText}>
                <Trans
                    i18nKey="Prompt.WouldYouLikeToDeleteFilling"
                    values={{fillingTitle: collectionName}}
                    components={{"strong-1": <strong />}}
                />
            </Text>
        </ChecklistModal>
    );
};
